import { VersionWrapper } from "./components/VersionWrapper"

const routes = [{ path: "/version", component: VersionWrapper }]

const settings = {
  routes,
}
export default settings
